import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import { toUIProps } from "../../../util";
import { Header as UIHeader } from 'semantic-ui-react';
var UNSUPPORTED_PROPS = ['as', 'className', 'content' // mutually exclusive with children
];
var MAPPED_PROPS = [];
var ADDED_PROPS = [];
var MODIFIED_PROPS = [];
var HeaderByline = createComponent({
  displayName: 'HeaderByline',
  parent: 'Header',
  propTypes: {
    children: PropTypes.node
  },
  defaultProps: {
    children: null
  },
  render: function render(props) {
    var UIProps = toUIProps({
      props: props,
      propMap: MAPPED_PROPS,
      UNSUPPORTED_PROPS: UNSUPPORTED_PROPS,
      ADDED_PROPS: ADDED_PROPS,
      MODIFIED_PROPS: MODIFIED_PROPS
    });
    return /*#__PURE__*/React.createElement(UIHeader.Subheader, UIProps, props.children);
  }
});
export default HeaderByline;
//# sourceMappingURL=header-byline.js.map